// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__L4Jla","logo":"Header_logo__ENg_O","navBarColor":"Header_navBarColor__2X-yj"};